import { CurrencyCodes } from '@onevesthq/ov-enums';
import { UserContext } from '@providers/userContextProvider';
import { useCallback, useContext } from 'react';
import { type FormatMoneyOptions, formatMoney } from '../utils';

export function useFormatMoney() {
  const { activeCurrency } = useContext(UserContext);
  const currency = activeCurrency || CurrencyCodes.CAD;

  return useCallback(
    (cents: number, opts: Omit<FormatMoneyOptions, 'currency'> = {}) =>
      formatMoney(cents, { ...opts, currency }),
    [currency],
  );
}
